/*
 * @Descripttion:
 * @version:
 * @Author: sujun
 * @email: 1373842098@qq.com
 * @Date: 2022-01-04 09:24:42
 * @LastEditors: linxi
 * @LastEditTime: 2022-09-28 16:29:29
 */
import { unwrapResult } from '@reduxjs/toolkit'
import { Modal, ModalProps, Form, Radio } from 'antd'
import React, { ReactElement, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootDispatch } from '../../app/store'
import {
  setAppShadeIsModal,
  setAppShadeTipText,
} from '../../layouts/layoutSlice'
import {
  isBatchOpenReplaceMake,
  isOpenReplaceMake,
  isSetReplaceMake,
  selectReplaceOpentype,
  setReplaceOpentype,
} from './tenantSlice'

interface ReplaceMakrProps {
  replaceMakeId: number
  state?: any
  tenantIds?: any
  // replaceMakeStatus?: number
}

export const ReplaceMakeModal = ({
  replaceMakeId,
  state,
  tenantIds,
  // replaceMakeStatus,
  onCancel,
  onOk,
  visible,
  ...others
}: ReplaceMakrProps & ModalProps): ReactElement => {
  const dispatch = useDispatch<RootDispatch>()

  const [form] = Form.useForm()

  // const replaceMakeId = useSelector(selectReplaceId)

  const replaceMakeStatus = useSelector(selectReplaceOpentype)

  const [isLoading, setIsLoading] = useState(false)

  const [isOpen, setIsOpen] = useState(false)

  console.log(state, 'state')

  useEffect(() => {
    if (!isOpen) {
      form.setFieldsValue({
        openGranuleType: 0,
        openHerbType: 0,
        recipeType: 0,
        openPriceRatio: 0,
        printBarCode: 1,
      })
    } else {
      form.setFieldsValue({
        openGranuleType: 1,
        openHerbType: 1,
        recipeType: 1,
        openPriceRatio: 1,
        printBarCode: 1,
      })
    }
  }, [isOpen])

  const required = {
    rules: [
      {
        required: true,
      },
    ],
  }

  useEffect(() => {
    console.log('replaceMakeId', replaceMakeId, replaceMakeStatus)
    if (!visible) return
    if (replaceMakeStatus === 0 && replaceMakeId) {
      // 已经开通代煎
      dispatch(isSetReplaceMake(replaceMakeId))
        .then(unwrapResult)
        .then((res: any) => {
          console.log(123, res)
          form.setFieldsValue({ ...res })
        })
    } else {
      form.setFieldsValue({
        openGranuleType: 0,
        openHerbType: 0,
        recipeType: 0,
        openType: 0,
        openPriceRatio: 0,
        printBarCode: 1,
      })
    }
  }, [replaceMakeId, visible])

  return (
    <Modal
      {...others}
      title={replaceMakeStatus ? '开通代煎' : '代煎选项设置'}
      width={600}
      confirmLoading={isLoading}
      cancelText='取消'
      visible={visible}
      okText='确定'
      onCancel={(e) => {
        form.setFieldsValue({
          openType: 0,
          openGranuleType: 0,
          openHerbType: 0,
          recipeType: 0,
          openPriceRatio: 0,
          printBarCode: 1,
        })
        setIsOpen(false)
        onCancel && onCancel(e)
      }}
      onOk={(e) => {
        state == 2
          ? form
              .validateFields()
              .then((values) => {
                dispatch(setAppShadeIsModal(true))
                dispatch(setAppShadeTipText('正在处理中，请稍后~~~'))
                dispatch(setReplaceOpentype(values.openType))
                dispatch(
                  isBatchOpenReplaceMake({ ...values, tenantIds: tenantIds })
                )
                  .then(unwrapResult)
                  .then(() => {
                    form.setFieldsValue({
                      openType: 0,
                      openGranuleType: 0,
                      openHerbType: 0,
                      recipeType: 0,
                      openPriceRatio: 0,
                      printBarCode: 1,
                    })
                    dispatch(setAppShadeIsModal(false))
                    dispatch(setAppShadeTipText('请稍后~~~'))
                    setIsOpen(false)
                    onOk && onOk(e)
                  })
                console.log(values)
              })
              .catch(() => {
                // Do nothing.
              })
          : form
              .validateFields()
              .then((values) => {
                dispatch(setReplaceOpentype(values.openType))
                dispatch(
                  isOpenReplaceMake({ ...values, tenantId: replaceMakeId })
                )
                  .then(unwrapResult)
                  .then(() => {
                    form.setFieldsValue({
                      openType: 0,
                      openGranuleType: 0,
                      openHerbType: 0,
                      recipeType: 0,
                      openPriceRatio: 0,
                      printBarCode: 1,
                    })
                    setIsOpen(false)
                    onOk && onOk(e)
                  })
                console.log(values)
              })
              .catch(() => {
                // Do nothing.
              })
      }}
    >
      <Form form={form} colon={false} autoComplete='off'>
        <Form.Item label='是否开通代煎' name='openType' {...required}>
          <Radio.Group
            onChange={(e) => {
              setIsOpen(!!e.target.value)
              console.log(!!e.target.value)
            }}
          >
            <Radio value={0}>是</Radio>
            <Radio value={1}>否</Radio>
          </Radio.Group>
        </Form.Item>
        <Form.Item label='是否开通中药代煎' name='openHerbType' {...required}>
          <Radio.Group disabled={isOpen}>
            <Radio value={0}>是</Radio>
            <Radio value={1}>否</Radio>
          </Radio.Group>
        </Form.Item>
        <Form.Item
          label='是否开通颗粒剂代煎'
          name='openGranuleType'
          {...required}
        >
          <Radio.Group disabled={isOpen}>
            <Radio value={0}>是</Radio>
            <Radio value={1}>否</Radio>
          </Radio.Group>
        </Form.Item>
        <Form.Item label='是否自动上传' name='recipeType' {...required}>
          <Radio.Group disabled={isOpen}>
            <Radio value={0}>是</Radio>
            <Radio value={1}>否</Radio>
          </Radio.Group>
        </Form.Item>
        <Form.Item label='代煎比价' name='openPriceRatio' {...required}>
          <Radio.Group disabled={isOpen}>
            <Radio value={0}>是</Radio>
            <Radio value={1}>否</Radio>
          </Radio.Group>
        </Form.Item>
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: 24 }}>
          <div
            style={{
              width: 148,
              marginRight: 4,
              textAlign: 'left',
              whiteSpace: 'nowrap',
            }}
          >
            <span style={{ color: '#ff4d4f', marginRight: 4 }}>*</span>
            是否打印代煎条形码
          </div>
          <Form.Item
            name='printBarCode'
            initialValue={1}
            {...required}
            style={{ marginBottom: 0 }}
          >
            <Radio.Group disabled={isOpen}>
              <Radio value={0}>是</Radio>
              <Radio value={1}>否</Radio>
            </Radio.Group>
          </Form.Item>
          <span style={{ color: '#999', marginLeft: 8, whiteSpace: 'nowrap' }}>
            作用于定制版的结算小票 (80cm)
          </span>
        </div>
      </Form>
    </Modal>
  )
}
